/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { useForm } from "react-hook-form";
import "react-datepicker/dist/react-datepicker.css";
import "./index.css";

import {
  StyledInput,
  StyledInputContainer,
  StyledInputGroup,
  StyledLabel,
  StyledSelect,
  StyledSelectContainer,
  StyledSelectGroup,
} from "../../StyledCss/styledInputs";
import { PrimaryButton, SecondaryButton } from "../../StyledCss/styledbtn";
import { applyUserExtraWork, getHolidaysByYear, getUserData } from "../../api/services/hroneApi";
import { ErrorText } from "../../StyledCss/styledComponents";

const Extraworkform = ({
  hrList,
  extraworkApplied,
  notifySuccess,
  closeBtn,
}) => {
  const [lastMonth, setLastMonth] = useState("");
  const [currentMonth, setCurrentMonth] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [dateError, setDateError] = useState(false);
  const [holidaysList, setHolidaysList] = useState([]);

  useEffect(() => {
    const today = new Date();
    const currentMonth = today.getMonth() + 1;
    let month = today.getMonth() - 1;
    let year = today.getFullYear();
    const day = today.getDate();

    if (month < 0) {
      month = 12;
    } else if (month < 10) {
      month = `0${month + 1}`;
    }

    if (currentMonth < month) {
      year = year - 1;
    }

    const formattedLastMonth = `${year}-${month}-${day}`;

    setLastMonth(formattedLastMonth);
  }, []);

  useEffect(() => {
    const today = new Date();
    let month = today.getMonth() + 1;
    const year = today.getFullYear();
    const day = today.getDate();

    if (month < 10) {
      month = `0${month}`;
    }
    const formattedCurrentMonth = `${year}-${month}-${day}`;
    setCurrentMonth(formattedCurrentMonth);
  }, []);

  useEffect(() => {
    const fetchHolidays = async () => {
      const holidaysYear = new Date().getFullYear();
      const response = await getHolidaysByYear(holidaysYear);
      if (response.status === 200) {
        const holidaysData = await response.json();
        setHolidaysList(holidaysData);
      }
    };
    fetchHolidays();
  }, []);

  const isDateDisabled = (date) => {
    const day = date.getDay();
    if (day === 0 || day === 6) return true;
    const dateStr = format(date, "yyyy-MM-dd");
    if (holidaysList.includes(dateStr)) return true;
    return false;
  };

  const renderDayContents = (day, date) => {
    const isWeekend = date.getDay() === 0 || date.getDay() === 6;
    const isHoliday = holidaysList.includes(format(date, "yyyy-MM-dd"));
    const isWorkingDay = !isWeekend && !isHoliday;
    return (
      <span style={isWorkingDay ? { textDecoration: "line-through", color: "#eb1616" } : {}}>
        {day}
      </span>
    );
  };

  const onChangeDate = (date) => {
    const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
    if (formattedDate !== "") {
      setDateError(false);
      setSelectedDate(formattedDate);
    } else {
      setDateError(true);
      setSelectedDate(formattedDate);
    }
  };

  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { empId, email } = getUserData();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    if (!selectedDate) {
      setDateError(true);
      return;
    }
    handleApplyReimbursement(data);
  };

  const handleApplyReimbursement = async (formData) => {
    const data = {
      employee_id: empId,
      employee_email: email,
      hr_email: formData.lead,
      date: selectedDate,
      hours: formData.hours,
      status: "Awaiting",
    };

    try {
      setIsLoading(true);
      const response = await applyUserExtraWork(data);

      if (response.status === 200) {
        extraworkApplied();
        notifySuccess();
      } else {
        const data = await response.json();
        setErrorMsg(data.detail);
      }
    } catch (error) {}
    finally {
      setIsLoading(false);
    }
  };

  return (
    <form
      autoComplete="off"
      onSubmit={handleSubmit(onSubmit)}
      className="d-flex flex-column gap-4 mt-3"
    >
      <div className="d-flex gap-3 apply-reimbursement-container">
        <StyledInputGroup>
          <StyledInputContainer>
            <DatePicker
              selected={selectedDate ? new Date(`${selectedDate}T00:00:00`) : null}
              onChange={onChangeDate}
              minDate={lastMonth ? new Date(lastMonth) : null}
              maxDate={currentMonth ? new Date(currentMonth) : null}
              filterDate={isDateDisabled}
              renderDayContents={renderDayContents}
              dateFormat="yyyy-MM-dd"
              placeholderText="Select Date"
              customInput={
                <StyledInput
                  style={dateError ? { borderLeft: "10px solid red" } : {}}
                  name="date"
                />
              }
            />
            <StyledLabel hasValue={true} className="user-label">
              Select Date*
            </StyledLabel>
          </StyledInputContainer>
        </StyledInputGroup>

        <StyledInputGroup>
          <StyledInputContainer>
            <StyledInput
              style={errors.hours && { borderLeft: "10px solid red" }}
              {...register("hours", { required: true, pattern: /^[1-8]$/ })}
              type="text"
            />
            <StyledLabel hasValue={true} className="user-label">
              Select Hours*
            </StyledLabel>
          </StyledInputContainer>
        </StyledInputGroup>

        <StyledSelectGroup>
          <StyledSelectContainer>
            <StyledSelect
              style={errors.lead && { borderLeft: "10px solid red" }}
              {...register("lead", { required: true })}
            >
              <option value="">Select Your Lead :</option>
              {Array.isArray(hrList) &&
                hrList.map((hr) => (
                  <option key={hr} value={hr}>
                    {hr}
                  </option>
                ))}
            </StyledSelect>
            <StyledLabel className="user-label">Select Your Lead*</StyledLabel>
          </StyledSelectContainer>
        </StyledSelectGroup>
      </div>

      {errors.hours && (
        <ErrorText>*The value should be between 1 to 8</ErrorText>
      )}

      {errorMsg && <ErrorText>*{errorMsg}</ErrorText>}

      <div className="d-flex justify-content-end gap-3">
        <SecondaryButton type="button" onClick={closeBtn}>
          Cancel
        </SecondaryButton>
        <PrimaryButton type="submit" disabled={isLoading}>
          {isLoading ? "Submitting..." : "Submit"}
        </PrimaryButton>
      </div>
    </form>
  );
};

export default Extraworkform;
